export default __webpack_public_path__ + "static/media/cherry-list-is-empty.003f0856.png";